export default __webpack_public_path__ + "static/media/instructions-thumb.91c6c7d6.jpg";